export type OGPJobsListingExternalParams = {
  readonly departmentId?: string | undefined;
  readonly search?: string | undefined;
};

export type OGPJobsListingSetParams = (params: OGPJobsListingExternalParams) => void;

export const WORK_TEMPLATE_INITIAL_VALUES = {
  search: {
    initialValue: undefined,
    type: 'string',
  },
  departmentId: {
    initialValue: undefined,
    type: 'string',
  },
} as const;
